angular.module('picmonicng').filter('dateToIso', function () {
  return function (input) {
    if (input) {
      var date = isNaN(input) ? input : input * 1000;
      return new Date(date).toISOString();
    }
  };
});
